import React from 'react'
import '../Aboutus/Aboutus.css'
import about1 from "../../img/about3.png";
import { Link } from 'react-router-dom';

function Aboutus() {
  return (
    <section className="about-section py-5">
    <div className="container">
      <div className="row align-items-center">

        
        <div className="col-lg-7 mb-4 mb-lg-0">
          <h6 className="text-uppercase  fw-bold" style={{color:'#cf6511'}}>Book A Schedule</h6>
          <h2 className="fw-bold mb-3">
            Book Us for your Event <br/>
            {/* <span class="text-dark">Book Us for your Event</span> */}
          </h2>
          <p className="text-muted">At Raju Caterers, we believe every event deserves a memorable culinary experience. With years of expertise and a trusted reputation in the Indian catering industry, we provide more than just food — we deliver an experience that delights your guests and makes your event truly unforgettable.
          </p>
          <p className="text-muted">Guided by the ethos “अतिथि देवो भवः” (Guests are like God), our mission is to serve wholesome, high-quality meals that bring people together and leave lasting impressions.</p>
          <p className="text-muted">Whether it’s a private celebration, corporate gathering, or large-scale social event, our team ensures seamless service, timely execution, and flavors that captivate every palate.</p>
          <p className="text-muted">Our carefully curated menu offers a diverse selection of dishes, blending tradition with innovation. Each recipe is crafted with fresh ingredients, meticulous preparation, and elegant presentation.</p>
           <Link 
      to="/about" 
      className="btn btn-danger mt-3 fw-bolder" 
      style={{ backgroundColor: "#cf6511" }}
    >
      Book Now
    </Link>
        </div>

        
        <div className="col-lg-5 text-center position-relative">
          <div className="image-wrapper">
            <img src={about1} alt="About Us" class="img-fluid"/>
            <div className="shape" style={{backgroundColor:'#cf6511'}}></div>
          </div>
        </div>

      </div>
    </div>
  </section>
  )
}

export default Aboutus
